import React, { useState, useEffect } from 'react'
import Player from '../player';
import Map from '../map'
import API from "../../utils/API";
import { useHistory, useParams } from "react-router-dom";
import handleKeydown, { handleKeyDown } from "../player/movement"

import { Cliffside } from '../../data/maps/1'
import store from '../../config/store'
import MusicBtn from '../../components/SoundBtns/MusicBtn';
import { resolveStageEntrySpawn, prepareConnectedTransition } from '../../config/worldTransitions';


//creates the cliff map
function CliffWorld(props) {
    let tiles = Cliffside
    
    const { id } = useParams();
    const history = useHistory();
    store.dispatch({
        type: 'ADD_TILES', payload: {
            tiles,
        }
    });
    const [userAvatar, setUserAvatar] = useState(null)
    useEffect(() => {
        API.UpdateSpritePlace("cliff", id).then(()=> {
        })
        // API.getUserSprite(id).then(user => {
        //     const { sprite } = user.data[0].sprite[0]
        //     return setUserAvatar(sprite)
        // })
    }, []);

    

    // A pending forest entrance must survive the loading rerender.
    const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "cliff", props.initialPosition));

    return (
        <div
            id="world-container"
            style={{
                position: 'relative',
                width: 'min(968px, calc(100vw - 2rem))',
                top: '35%',
                margin: '0 auto',
                border: '4px solid black',
                borderRadius: '5px'
            }}
        >
            <MusicBtn />
            <Map />
            <Player
                avatar={props.avatar}
                avatarName={props.avatarName}
                initialPosition={initialPosition}
                exitZones={{ WEST: [[0, 7]] }}
                onRightEdge={(position) => {
                    prepareConnectedTransition(id, 'cliff', 'WEST', [position[0] / 64, position[1] / 64]);
                    history.push('/forest/' + id);
                }}
            />
        {/* onKeyDown={handleKeyboard} */}
        </div>
    )
}

export default CliffWorld;